import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

import { bsc } from '@reown/appkit/networks'

export const projectId = process.env.REACT_APP_WALLET_ID

export const networks = [bsc];

if (!projectId) {
  throw new Error('Project ID is not defined')
}

export const metadata = {
  name: 'Thepill',
  description: 'AppKit Example',
  url: 'https://thepillcoin.com/',
  icons: ['https://avatars.githubusercontent.com/u/179229932']
}
export const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks,
})

export const config = wagmiAdapter.wagmiConfig
